/* Bodega de Arte: navigation for grouped desktop menu (v05). */
(() => {
  function init(root = document) {
    root.querySelectorAll('.bda-nav:not([data-bda-ready])').forEach(nav => {
      nav.dataset.bdaReady = 'true';
      const groups = [...nav.querySelectorAll('.bda-nav__group > details')];
      const closeOthers = active => groups.forEach(d => { if (d !== active) d.open = false; });
      groups.forEach(details => {
        const summary = details.querySelector(':scope > summary');
        const sync = () => summary.setAttribute('aria-expanded', String(details.open));
        sync();
        details.addEventListener('toggle', () => { if (details.open) closeOthers(details); sync(); });
        details.parentElement.addEventListener('pointerenter', e => {
          if (e.pointerType === 'mouse' || e.pointerType === 'pen') { closeOthers(details); details.open = true; }
        });
        details.parentElement.addEventListener('pointerleave', e => {
          if (e.pointerType === 'mouse' || e.pointerType === 'pen') details.open = false;
        });
        summary.addEventListener('click', () => closeOthers(details));
        details.addEventListener('keydown', e => {
          if (e.key === 'Escape') { details.open = false; summary.focus(); e.stopPropagation(); }
        });
        details.addEventListener('focusout', e => {
          if (!details.contains(e.relatedTarget)) details.open = false;
        });
      });
      document.addEventListener('pointerdown', e => { if (!nav.contains(e.target)) closeOthers(null); });
      nav.addEventListener('mouseleave', () => closeOthers(null));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
